const PLATFORM_DOMAIN = (process.env.REACT_APP_PLATFORM_DOMAIN || 'reelisle.com').toLowerCase();
export const ADMIN_PORTAL_HOST = (process.env.REACT_APP_ADMIN_PORTAL_HOST || `reeladmin.${PLATFORM_DOMAIN}`).toLowerCase();
export const AGENT_PORTAL_HOST = (process.env.REACT_APP_AGENT_PORTAL_HOST || `partner.${PLATFORM_DOMAIN}`).toLowerCase();

export function normalizeHost(rawHost = '') {
  return String(rawHost || '')
    .split(',', 1)[0]
    .trim()
    .toLowerCase()
    .replace(/:\d+$/, '')
    .replace(/^www\./, '');
}

export function isAdminPortalHost(hostname = null) {
  if (typeof window === 'undefined' && !hostname) return false;
  const host = normalizeHost(hostname || window.location.hostname);
  return host === ADMIN_PORTAL_HOST;
}

export function isAgentPortalHost(hostname = null) {
  if (typeof window === 'undefined' && !hostname) return false;
  const host = normalizeHost(hostname || window.location.hostname);
  return host === AGENT_PORTAL_HOST;
}

export function getPlayerOrigin() {
  const protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:';
  return process.env.REACT_APP_PLAYER_ORIGIN || `${protocol}//${PLATFORM_DOMAIN}`;
}

export function getReservedSubdomains() {
  return new Set(['www', 'reeladmin', 'partner']);
}
